<template>
    <div>
        <lounge v-if="!room && !feedback" @start-session="startSession"/>
        <room v-if="room && !feedback" @end-session="endSession"/>
        <feedback v-if="!room && feedback" @re-join="reJoin" @show-lounge="showLounge"/>
    </div>
</template>

<script>
import lounge from "./lounge";
import room from "./room";
import feedback from "./feedback";
    export default {
        name:"sessions",
        data() {
            return {
                room: false,
                feedback: false
            }
        },
        components: {
            lounge,
            room,
            feedback
        },
        methods: {
            startSession() {
                this.room = true;
            },
            endSession(){
                this.room = false,
                this.feedback = true;
            },
            reJoin(){
                this.feedback = false;
                this.room = true;
            },
            showLounge(){
                this.room = false,
                this.feedback = false
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>